/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CountryManagerResponse } from './';
import {
    CountryManagerResponseFromJSON,
    CountryManagerResponseFromJSONTyped,
    CountryManagerResponseToJSON,
} from './';
import type { CountryResponse } from './';
import {
    CountryResponseFromJSON,
    CountryResponseFromJSONTyped,
    CountryResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportedCountryWithManagers
 */
export interface SupportedCountryWithManagers {
    /**
     * 
     * @type {CountryResponse}
     * @memberof SupportedCountryWithManagers
     */
    country: CountryResponse;
    /**
     * 
     * @type {Array<CountryManagerResponse>}
     * @memberof SupportedCountryWithManagers
     */
    managers: Array<CountryManagerResponse>;
}

/**
 * Check if a given object implements the SupportedCountryWithManagers interface.
 */
export function instanceOfSupportedCountryWithManagers(value: object): value is SupportedCountryWithManagers {
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('managers' in value) || value['managers'] === undefined) return false;
    return true;
}

export function SupportedCountryWithManagersFromJSON(json: any): SupportedCountryWithManagers {
    return SupportedCountryWithManagersFromJSONTyped(json, false);
}

export function SupportedCountryWithManagersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportedCountryWithManagers {
    if (json == null) {
        return json;
    }
    return {
        
        'country': CountryResponseFromJSON(json['country']),
        'managers': ((json['managers'] as Array<any>).map(CountryManagerResponseFromJSON)),
    };
}

export function SupportedCountryWithManagersToJSON(value?: SupportedCountryWithManagers | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'country': CountryResponseToJSON(value['country']),
        'managers': ((value['managers'] as Array<any>).map((v) => CountryManagerResponseToJSON(v))),
    };
}

